



























































































































































import {Vue, Component, Ref, Prop, Watch} from 'vue-property-decorator';
import {Getter, Action} from "vuex-class";
import {
  Collapse,
  NewPriceWings,
  SelectWings,
  SpoilerWings,
  ToggleWings
} from "wings-ui-components";
import {cloneDeep, isEqual} from "lodash";
import {notifyConfirm, notifyDelete, notifyError} from "@/utils/notify-helper";
import {TariffItem, TarificationTransports, TarificationTypes} from "@/store/tarification/types";
import { removeItem } from '@/utils/data-helper';
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";

@Component({components: {
  SelectWings,
  NewPriceWings,
  ToggleWings,
  Collapse,
  SpoilerWings,
}})
export default class Tariff extends Vue {

  @Ref('validator') validator: any;

  @Prop() transport!: TarificationTransports;
  @Prop() type!: TarificationTypes;

  @Action("getPartners") actionGetPartners: any;
  @Action("getServiceProviders") actionGetServiceProviders: any;
  @Action("getTariffItem") actionGetItem: any;
  @Action("saveTariffItem") actionSave: any;
  @Action("deleteTariffItem") actionDelete: any;
  @Action("getMessageCategories") actionGetMessageCategories: any;
  @Action("actionLog") actionLog: any;

  @Getter("messageCategories") messageCategoriesList: any;

  private partnerType: TarificationTypes = TarificationTypes.PARTNER;
  private operatorType: TarificationTypes = TarificationTypes.OPERATOR;
  private pushTransport: TarificationTransports = TarificationTransports.PUSH;

  private item = this.defaultItem();
  private itemSaved = this.defaultItem();

  private selectedCategories = [];
  private useCategories: boolean = false;
  private logObject: ActionLog = {};

  get isOperatorType(): boolean {
    return this.type === TarificationTypes.OPERATOR;
  }

  get isSmsOrWhatsappOrViber(): boolean {
    return [
      TarificationTransports.SMS,
      TarificationTransports.WHATSAPP,
      TarificationTransports.VIBER,
      TarificationTransports.MAILNOTIFY,
      TarificationTransports.CUSTOM,
    ].includes(this.transport);
  }

  defaultItem(): TariffItem {
    return {
      id: undefined,
      partner_id: undefined,
      service_provider_id: undefined,
      price: undefined,
      message_categories_prices: undefined,
    };
  }

  params = {transport: this.transport};
  partnersList: any = []
  serviceProvidersList: any = []

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({...this.params, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async getServiceProvidersList(filter: any) {
    const items = await this.actionGetServiceProviders({...this.params, ...filter});
    this.serviceProvidersList = (filter?.page_number > 1) ? this.serviceProvidersList.concat(items) : items
  }

  async created() {
    if (this.$route.params.id) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "Tariff",
          addititional_info: getTranslatedParams(this.item)
        }
        const object = {
          tariffType: this.type,
          tariff_id: this.$route.params.id,
          transport: this.transport
        };
        const data = await this.actionGetItem(object);
        await this.actionLog(this.logObject);
        this.item = Object.assign({}, this.item, data);
        this.itemSaved = cloneDeep(Object.assign({}, this.item, data));
      } catch (error){
        this.actionLog({...this.logObject, action_status: "failed"});
      }
      if (this.item.partner_id) this.partnersList = await this.actionGetPartners({id: this.item.partner_id});
      if (this.item.service_provider_id) this.serviceProvidersList = await this.actionGetServiceProviders({id: this.item.service_provider_id});
    }

    await this.actionGetMessageCategories(this.params);

    if (this.item.message_categories_prices && this.item.message_categories_prices.length) {
      this.useCategories = true;
    } else {
      this.useCategories = false;
    }
  }

  back(): void {
    this.$router.push(`/${this.transport.toLowerCase()}/${this.type}/tariffs`);
  }

  async onSaveItem(): Promise<void> {
    const valid: boolean = await this.validator.validate();
    if (valid) {
      if (!this.checkDuplicate(this.item.message_categories_prices)) {
        const object = {
          tariffType: this.type,
          item: this.item,
          transport: this.transport
        };
        try {
          this.logObject = {
            action_page: this.$route.meta.msgKey,
            action: this.$route.params.id ? "Editing" : "Creation",
            action_status: "success",
            object_type: "Tariff",
            addititional_info: getTranslatedParams(this.item)
          }
          await this.actionSave(object);
          await this.actionLog(this.logObject);
          this.itemSaved = this.item;
          this.back();
        } catch (error) {
          await this.actionLog({...this.logObject, action_status: "failed"});
          notifyError(error);
          throw error
        }
      } else {
        setTimeout(() => {
          notifyError(null, null, "Для одной категории можно задать только одну цену")
        }, 100);
      }
    } else {
      setTimeout(() => {
        notifyError(null, this.validator.errors)
      }, 100);
      throw new Error();
    }
  }

  async onDeleteItem(): Promise<void> {
    const isConfirm: boolean = await notifyDelete();
    if (isConfirm) {
      const object = {
        item: this.item,
        transport: this.transport,
        tariffType: this.type
      } ;
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "Tariff",
          addititional_info: getTranslatedParams(object)
        }
        await this.actionDelete(object);
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
        throw error
      }
    }
  }

  // TODO условие надо будет убрать после приведение "mail notify" и "mail_notify" в единый формат
  public beforeLeave(to:any, from:any, next:any) {
    let isChange = !isEqual(this.item,this.itemSaved);
    if (to.name) notifyConfirm(isChange, this.onSaveItem, next);
    else next();
  }

/** Далее функционал категорий:
 *
 * TODO: Все это дело лучше вынести куда-то. Например в отдельный компонент, и наследоваться от него.
 *
*/

  // Из vue-material.md-table
  onSelect(items: any) {
    this.selectedCategories = items;
  }

  // Добавить строку в табл. категорий
  addEmptyCategory(): void {
    if (this.item.message_categories_prices === undefined) {
      this.item.message_categories_prices = [];
    }
    this.item.message_categories_prices.push({message_category_id: undefined, price: undefined});
  }

  // Удаление строки/строк из табл. категорий
  deleteSelectedCategories(): void {
    if (this.item.message_categories_prices) {
      this.selectedCategories.forEach((rule: any) =>
        removeItem(this.item.message_categories_prices, rule));
      if (this.item.message_categories_prices.length === 0) {
        this.addEmptyCategory();
      }
    }
  }

  // Инициализация и очистка таблицы категорий при вкл-выкл свитча useCategories
  @Watch('useCategories')
  onChangeItemUseCategoriesPrices(newVal: boolean) {
    if (newVal) {
      if (this.item.message_categories_prices === undefined)
        this.item.message_categories_prices = []
      if (this.item.message_categories_prices.length === 0)
        this.addEmptyCategory();
    } else {
      this.item.message_categories_prices = undefined;
    }
  }

  checkDuplicate(message_categories: any): boolean {
    if (message_categories) {
      let valueArr = message_categories.map(function (item: any) {
        return item.message_category_id
      });
      let isDuplicate = valueArr.some(function (item: any, idx: any) {
        return valueArr.indexOf(item) != idx
      });
      return isDuplicate
    } else {
      return false
    }
  }
}
